import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminComponent } from './admin.component';
import { UserModule } from './users/user.module';
import { RoleModule } from './roles/role.module';
import { SharedModule } from '../../shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppMaterialModule } from '../../shared/appMaterial/app-material.module';
import { WaterBodiesModule } from './water-bodies/water-bodies.module';
import { BookingsModule } from './bookings/bookings.module';
import { CouponsModule } from './coupons/coupons.module';
import { CaptainsModule } from './captains/captains.module';
import { VesselsModule } from './vessels/vessels.module';
import { ReportsModule } from './reports/reports.module';
import { BoatOwnerModule } from './boat-owners/boat-owner.module';
import { UnverifiedCustomersModule } from './customers/unverified-customers/unverified-customers.module';
import { AffiliateGridModule } from './affiliate-grid/affiliate-grid.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  imports: [
    CommonModule,
    AppMaterialModule,
    UserModule,
    RoleModule,
    WaterBodiesModule,
    BookingsModule,
    SharedModule,
    CouponsModule,
    CaptainsModule,
    FlexLayoutModule,
    VesselsModule,
    ReportsModule,
    BoatOwnerModule,
    UnverifiedCustomersModule,
    AffiliateGridModule,
    MatProgressBarModule,
  ],
  declarations: [AdminComponent],
  exports: [AdminComponent],
  providers: [],
})
export class AdminModule {}
